/**
* @author: sai shiva
* @Date: 2022-09-16 11:20:00
* @Last Modified by: sai shiva
* @Last Modified time: 2022-09-16 11:55:00
*/

const IMG_IMPORTS = {
  WEARABLES_GADGET_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/wearble-gadget.webp',
    ALT: 'wearable-gadget-image',
  },
  WEARABLES_GADGET_BOX_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/wearable-special-box.webp',
    ALT: 'wearable-gadget-special-box-image',
  },
  WEARABLES_LOGIN_SINGUP_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/login-singup-wearable.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_ACTIVE_KEY_FOB: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/active-key-fob.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_COMPLETE_KYC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/complete-kyc.webp',
    ALT: 'wearable-ICONS',
  },
  ANNUAL_INVESTOR_TEAM: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/team-annual-investor.webp',
    ALT: 'annual team investor',
  },
  ANNUAL_INVESTOR_CONTACT_MAIL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/contact-mail-annual-investor.webp',
    ALT: 'contact mail annual investor',
  },
  ANNUAL_INVESTOR_REPORT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/report-annual-investor.webp',
    ALT: 'report annual investor',
  },
  WEARABLES_CAFETERIA_SOLUTION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/cafeteria-solution.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_TRANSIT_SOLUTION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/transit-solution.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/wearable-landing.webp',
    ALT: 'wearable-landing-image',
  },
  WEARABLES_TRULY_CONTATCLESS_EXPERIENCE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/truly-contactless-experience.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_FASHIONABLE_FINTECH: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/fashionable-fintech.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_FAST_SECURE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/fast-secure.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_HASSLE_FREE_SETUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/hassle-free-setup.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_EASYONLINE_TRANSACTION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/easy-online-transactions.webp',
    ALT: 'wearable-ICONS',
  },
  WEARABLES_EASY_ENABLE_DISABLE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/wearables/easy-enable-disable.webp',
    ALT: 'wearable-ICONS',
  },
  XMAS_BANNER_CORPORATE_GIFTING: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/xmas-campaign.webp',
    ALT: 'Chirstmas Banner Corporate Gifting',
  },
  NEWYEAR_BANNER_CORPORATE_GIFTING: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/new-year-campaign.webp',
    ALT: 'NewYear Banner Corporate Gifting',
  },
  XMAS_BANNER_PROPEL_CORPORATE_GIFTING: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/webp/christmas-pcg-banner.webp',
    ALT: 'Xmas Special Banner',
  },
  XMAS_SANTA: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/webp/santa-pcg-icon.webp',
    ALT: 'Xmas Special Santa',
  },
  XMAS_TREE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/webp/pcg-xmas-tree.webp',
    ALT: 'Xmas Special Tree',
  },
  SHAREHOLDER_INFORMATION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/shareholder-info.webp',
    ALT: 'Shareholder Information',
  },
};

const PDF_IMPORTS = {
  // Annual Reports Investor Relations Start
  ANNUAL_RETURN_FY_21_22: 'https://cdn.zaggle.in/images/web/zaggle/pdf/annual-financials/annual-return-21-22.pdf',
  ANNUAL_RETURN_FY_22_23: 'https://cdn.zaggle.in/images/web/zaggle/pdf/annual-financials/annual-return-22-23.pdf',
  PART_F_OF_SEBI_DISCLOSURE: 'https://cdn.zaggle.in/images/web/zaggle/pdf/annual-financials/part-f-of-SEBI-Disclosure.pdf',
  PART_F_SCHEDULE_I: 'https://cdn.zaggle.in/images/web/zaggle/pdf/annual-financials/part-f-schedule-i-2022-23.pdf',
  CSR_POLICY: 'https://cdn.zaggle.in/images/web/zaggle/pdf/annual-financials/CSR-policy.pdf',
  FINANCIAL_STATEMENTS_1: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_examination_report_march_2023.pdf',
  FINANCIAL_STATEMENTS_2: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_audit_report_m23_standalone.pdf',
  FINANCIAL_STATEMENTS_3: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_fs_mar_2023_consolidated.pdf',
  FINANCIAL_STATEMENTS_4: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_fs_mar_2023_standalone.pdf',
  FINANCIAL_STATEMENTS_5: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_restated_fs_mar23_22_21_Aug23.pdf',
  FINANCIAL_STATEMENTS_6: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zposl_auditors_report_fy22.pdf',
  FINANCIAL_STATEMENTS_7: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zposl_financials_fy22.pdf',
  FINANCIAL_STATEMENTS_8: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/auditors_report_fy21.pdf',
  FINANCIAL_STATEMENTS_9: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zposl_financials_fy21.pdf',
  FINANCIAL_STATEMENTS_10: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle_audit_report_consolidated.pdf',

  FINANCIAL_STATEMENTS_11: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/financials-and-audit-report-2021.pdf',
  FINANCIAL_STATEMENTS_12: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/financials-and-audit-report-2022.pdf',
  FINANCIAL_STATEMENTS_13: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financial-statements/zaggle-standalone-consol-financials-22-23.pdf',


  STOCK_EXCHANGE_01: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-execution-of-contract-with-bfsl.pdf',
  STOCK_EXCHANGE_02: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-investor-or-analysts-meet-on-10.10.2023.pdf',
  STOCK_EXCHANGE_03: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-execution-of-contract-with-visa.pdf',
  STOCK_EXCHANGE_04: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-execution-of-contract-with-kotak.pdf',
  STOCK_EXCHANGE_05: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-execution-of-contract-with-toshiba.pdf',
  STOCK_EXCHANGE_06: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-investor-or-analysts-meet-on-22-11-2023-one.pdf',
  STOCK_EXCHANGE_07: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/intimation-to-stock-exchange/intimation-of-investor-or-analysts-meet-on-22-11-2023-two.pdf',


  COMMITTEE_CONSTITUTION: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/committee-composition/committee-constitution.pdf',
  // Annual Reports Investor Relations End


  WHISTLE_BLOWER_POLICY: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/vigil-mechanism-whistle-blower-policy.pdf',
  CORPORATE_SOCIAL_RESPONSIBILITY_POLICY: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-for-determining-material-subsidiaries.pdf',
  DETAILS_OF_FAMILIARIZATION_PROGRAMMES_IMPARTED: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/familiarization-programmes-imparted-to-independent-directors.pdf',

  // RHP
  RHP: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/RHP/zaggle-investing-rhp.pdf',

  ROSPECTUS: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/prospectus/zaggle-prepaid-ocean-services-limited-rospectus.pdf',

  DETAILS_OF_CREDITORS: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/list-of-material-creditors.pdf',

  BASIS_OF_ALLOTMENT: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/basis-of-allotment.pdf',

  // BOD
  BOD: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/BOD/board-of-directors.pdf',
  // MCDI
  MONITORING_AGENCY_AGREEMENT: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/monitoring-agency-agreement.pdf',
  AMENDMENT_TO_OFFER_AGREEMENT: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/amendment-to-offer-agreement.pdf',
  OFFER_AGREEMENTS_19TH_DEC_2022: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/offer-agreements-19th-dec-2022.pdf',
  REGISTRAR_AGREEMENT_15TH_DEC_2022: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/registrar-agreement-15th-dec-2022.pdf',
  LETTER_OF_INDEMNITY_REGISTRAR_AGREEMENT_15TH_DEC_2022: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/letter-of-Indemnity-(registrar-agreement)-15th-dec-2022.pdf',
  LOI_AMENDMENT_TO_REGISTRAR_AGREEMENT: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/MCDI/LOI-amendment-to-registrar-agreement.pdf',

};

const GIF_IMPORTS = {
  ZAGGLE_LOGO_XMAS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/gif/zaggle-christmas-logo.gif',
    ALT: 'zaggle xmas special logo',
  },
};

export {
  IMG_IMPORTS,
  PDF_IMPORTS,
  GIF_IMPORTS,
};



// WEBPACK FOOTER //
// client/devUtils/assests.js